import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle } from "lucide-react";

/**
 * Banner globale visibile a tutti gli utenti se la propria org è "suspended".
 * Per super_admin non viene mostrato (vede ogni org via /superadmin).
 */
export const SuspensionBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user || user.role === "super_admin") return;
    let mounted = true;
    api.get("/me/org-status")
      .then(({ data }) => { if (mounted) setStatus(data); })
      .catch(() => {});
    return () => { mounted = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  if (!user || user.role === "super_admin") return null;
  if (!status || status.status !== "suspended") return null;

  return (
    <div
      data-testid="suspension-banner"
      className="bg-danger-subtle border-b border-danger-subtle text-danger-strong px-6 py-3 flex items-center gap-3"
    >
      <AlertTriangle size={16} strokeWidth={2} className="flex-shrink-0" />
      <div className="text-sm font-medium">
        La tua organizzazione è temporaneamente sospesa. Contatta l'amministratore per maggiori informazioni.
      </div>
    </div>
  );
};
